
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { SingleCheckoutPage } from '@/domains/checkout/pages/SingleCheckoutPage/SingleCheckoutPage'
import { createGetServerSideProps } from '@/helpers/createGetServerSideProps'
import {
  GetItemCategoriesDocument,
  GetItemCategoriesQuery,
  GetItemCategoriesQueryVariables,
} from '@/types/gql/graphql'

export default function () {
  return <SingleCheckoutPage />
}

 const _getServerSideProps = createGetServerSideProps({
  async getServerSideProps({ client }) {
    await client.executeQuery<
      GetItemCategoriesQuery,
      GetItemCategoriesQueryVariables
    >({
      document: GetItemCategoriesDocument,
    })
  },
})


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/checkout/items/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  